const { locale } = document.querySelector('html').dataset;
const ajaxUrl = `/s/ajax/${locale}/`;

export default ajaxUrl;
